import React, { useCallback, useState } from 'react';
import moment, { Moment } from 'moment';

import { AverageDischargeChart } from '@components/chart/averageDischargeChart';
import { useTranslation } from '@lib/useTypedTranslation';
import { RequestInitWithRetry } from '@lib/request';
import { getSelectedDateDeviceChargeLevel, IDeviceDischarge } from '../../../services/core/devicePerformance';
import { useWorldRequest } from '@lib/useWorldRequest';
import { Loading } from '@components/loading/loading';
import { DeviceLevelChart } from './deviceLevelChart';

import './styles.css';


interface IProps {
  id: string,
  data: IDeviceDischarge[],
  isLoading?: boolean,
  timeZoneOffset?: number
}

export function DeviceCharts(props: IProps) {
  const { t } = useTranslation(['performance', 'translation']);
  const [deviceBatteryLevels, setDeviceBatteryLevels] = useState<any[]>();
  const [deviceLevelDate, setDeviceLevelDate] = useState(moment.utc().endOf('day').valueOf());
  const title = t('AVERAGE_HOURLY_DISCHARGE_PAST_30DAYS', { ns: 'performance' });

  const onDataFetched = useCallback((data: any) => {
    setDeviceBatteryLevels(data[0] as any);
  }, []);

  const dataFetcher = useCallback(() => {
    if (props.id) {
      const params: any = { deviceId: props.id, to: deviceLevelDate };
      return (options: RequestInitWithRetry) => {
        return Promise.all([
          getSelectedDateDeviceChargeLevel(params)(options)
        ]);
      };
    }
  }, [props.id, deviceLevelDate]);

  const { loading: isDataLoading } = useWorldRequest(dataFetcher, { onSuccess: onDataFetched });

  const onSetDate = (date: string | Moment) => setDeviceLevelDate(moment(date).utc().endOf('day').valueOf());

  return (
    <div className="row details_information h-100">
      <div className="col-md-6 col-sm-12 col-12">
        <AverageDischargeChart
          data={props.data}
          title={title}
          className={"device-average-discharge-chart"}
          setDate={onSetDate}
          isLoading={props?.isLoading}
          timeZoneOffset={props?.timeZoneOffset}
        />
      </div>
      <div className="col-md-6 col-sm-12 col-12">
        <Loading isLoading={isDataLoading} transparentOverlay={true}>
          <DeviceLevelChart
            data={deviceBatteryLevels}
            date={deviceLevelDate}
          />
        </Loading>
      </div>
    </div>
  );
}
